import { Icon, MenuItem, Select } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '../Box';
import { Input } from '../Input';
import { getInputLabel, getOptionsByColumnId, getIsSelectInput } from './columnFilter.helpers';
import { ColumnFilterProps } from './types';

const SelectFilter: React.FC<ColumnFilterProps> = ({ column }) => {
  const columnFilterValue = column.getFilterValue();
  const { t } = useTranslation();

  const { options, getLabel } = getOptionsByColumnId(column.id, t);

  const renderValue = (value: string) => {
    if (!value) {
      return <Box opacity={0.4}>{t('generic.filterPlaceholder')}</Box>;
    }

    return getLabel(value);
  };

  return (
    <Select
      value={(columnFilterValue as string) || ''}
      displayEmpty
      renderValue={renderValue}
      input={
        <Input
          inputLabel={getInputLabel(column.id, t)}
          icon={{
            component: <Icon>expand_more</Icon>,
            direction: 'right',
          }}
        />
      }
      onChange={e => column.setFilterValue(e.target.value)}>
      <MenuItem value="">{t('generic.includeAll')}</MenuItem>
      {options.map(option => (
        <MenuItem key={option} value={option}>
          {getLabel(option)}
        </MenuItem>
      ))}
    </Select>
  );
};

export const SearchFilter: React.FC<ColumnFilterProps> = ({ column }) => {
  const { t } = useTranslation();
  const columnFilterValue = column.getFilterValue();

  const isSelect = getIsSelectInput(column.id);

  return (
    <Box width="200px">
      {isSelect ? (
        <SelectFilter column={column} />
      ) : (
        <Input
          value={(columnFilterValue as string) || ''}
          onChange={e => column.setFilterValue(e.currentTarget.value)}
          inputLabel={getInputLabel(column.id, t)}
          placeholder={t('generic.filterPlaceholder')}
        />
      )}
    </Box>
  );
};
